import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "269",
  "slug": "spot-russia-from-satellite-imagery",
  "title": "How to Recognise Russia in Satellite Images",
  "excerpt": "Russia spans forest, steppe, tundra, and high mountain regions.",
  "date": "2026-05-04",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/russia.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Russia spans forest, steppe, tundra, and high mountain regions. A wide view of western Siberia can show broad lowlands and extensive drainage networks; farther east, rugged terrain becomes more prominent. The map here covers most of Eurasian Russia but does not include the full area across the antimeridian."
    },
    {
      "type": "heading",
      "text": "A country too large for one visual shortcut"
    },
    {
      "type": "paragraph",
      "text": "Compare the lowlands east of the Urals with more mountainous eastern Siberia. Use the river pattern to describe the relief you can actually see."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Canada has comparable boreal and Arctic landscapes, while Kazakhstan shares steppe and agricultural patterns. A small crop of trees or fields may not contain enough evidence to distinguish them. Avoid forcing a precise regional guess from colour alone."
    }
  ],
  "imageAlt": "Russia regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
